import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { LineItemModels, LineItemMappers, LineItemSlotsProvider, LineItemCard, DeliveryEstimation } from '@grandvisionhq/lib-visuals';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';

const LineItemsContainer = ({ lineItems  })=>{
    const intl = useIntl();
    const { isDynamicLineItemDeliveryEstimationEnabled =false  } = useFeatureToggles();
    const labels = React.useMemo(()=>({
            quantity: intl.getLabel('cart.item.quantity'),
            iconLeftEye: intl.getLabel('products.contactLenses.leftEye'),
            iconRightEye: intl.getLabel('products.contactLenses.rightEye'),
            power: intl.getLabel('products.contactLenses.prescription.power'),
            deliveredEvery: intl.getLabel('cart.delivery.frequency'),
            perBox: intl.getLabel('products.perBox'),
            configuration: intl.getLabel('account.order.detail.configuration'),
            prescription: intl.getLabel('account.order.detail.prescription'),
            subscriptionDetails: intl.getLabel('cart.item.subscription.title'),
            addOn: intl.getLabel('products.addOn.title'),
            delivery: intl.getLabel('products.deliveryEstimation.label'),
            deliveryTooltip: intl.getLabel('cart.lineItem.deliveryEstimation.tooltip', {
                hideLabelKey: true
            }),
            disclaimer: intl.getLabel('cart.lineItem.glasses.disclaimer', {
                hideLabelKey: true
            }),
            disclaimerTooltip: intl.getLabel('cart.lineItem.glasses.disclaimerTooltip', {
                hideLabelKey: true
            })
        })
    , [
        intl
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, lineItems.map((lineItem, i)=>{
        var ref3;
        const accordionSection = [];
        if ('prescription' in lineItem) {
            if (LineItemModels.isGlassesBundleLineItem(lineItem)) {
                accordionSection.push({
                    type: 'GLASSES_BUNDLE',
                    title: labels.prescription,
                    prescription: lineItem.prescription
                });
            } else if (lineItem.prescription) {
                accordionSection.push({
                    type: 'CONTACT_LENSES',
                    title: labels.prescription,
                    prescription: lineItem.prescription
                });
            }
        }
        if (lineItem.isSubscription && ((ref3 = lineItem.subscriptionDetails) === null || ref3 === void 0 ? void 0 : ref3.deliveryInterval)) {
            accordionSection.push({
                type: 'SUBSCRIPTION',
                title: labels.subscriptionDetails,
                expanded: true,
                deliveryInterval: lineItem.subscriptionDetails.deliveryInterval
            });
        }
        if ('bundleChildLineItems' in lineItem && lineItem.bundleChildLineItems) {
            var ref1;
            const bundleChildLineItems = LineItemMappers.getEnrichedBundleChildLineItems({
                lineItem,
                addOnLabel: labels.addOn
            });
            accordionSection.push(swcHelpers.objectSpread({
                type: 'GENERIC_BUNDLE',
                title: labels.configuration,
                bundleChildLineItems,
                expanded: Boolean((ref1 = lineItem.insurance) === null || ref1 === void 0 ? void 0 : ref1.sku)
            }, labels.disclaimer && {
                disclaimer: labels.disclaimer
            }, labels.disclaimerTooltip && {
                disclaimerTooltip: labels.disclaimerTooltip
            }));
        }
        const baseProps = {
            currency: intl.currency,
            discount: lineItem.discountPrice,
            originalPrice: lineItem.originalPrice,
            imagePath: lineItem.imageUrl,
            lineItemId: lineItem.lineItemId,
            price: lineItem.price,
            quantity: lineItem.quantity,
            subtitle: lineItem.subtitle,
            title: lineItem.title,
            isCompactCard: true,
            accordionSection,
            additionalInfo: lineItem.additionalInfo
        };
        const LineItemCardSlot = {
            DeliveryEstimation: isDynamicLineItemDeliveryEstimationEnabled ? ()=>{
                var ref, ref2;
                 return React.createElement(DeliveryEstimation, {
                    tooltipId: `delivery-estimation-tooltip-${lineItem.sku}${i}`,
                    labels: {
                        label: labels.delivery,
                        tooltip: labels.deliveryTooltip
                    },
                    earliestDeliveryDate: (ref = lineItem.deliveryEstimation) === null || ref === void 0 ? void 0 : ref.earliestDeliveryDate,
                    latestDeliveryDate: (ref2 = lineItem.deliveryEstimation) === null || ref2 === void 0 ? void 0 : ref2.latestDeliveryDate
                });
            } : undefined
        };
        return /*#__PURE__*/ React.createElement(LineItemSlotsProvider, {
            key: `${lineItem.sku}-${i}`,
            slots: LineItemCardSlot
        }, /*#__PURE__*/ React.createElement(LineItemCard, swcHelpers.extends({
            key: `${lineItem.lineItemId}+${i}`
        }, baseProps)));
    }));
};

export { LineItemsContainer };
//# sourceMappingURL=LineItemContainer.js.map
